﻿import { baseCrumbClasses } from "../Breadcrumbs";
import { DoubleShift, TripleShift } from "../../../types/Shift";
import { ListSelectCrumb } from "../ListSelectCrumb";

interface ShiftSelectCrumbProps {
  selectedShift: DoubleShift;
  setSelectedShift: (shift: DoubleShift) => void;
}

interface ShiftSelectCrumbProps {
  selectedShift: DoubleShift;
  setSelectedShift: (shift: DoubleShift) => void;
  showAfternoonShift?: false;
}

interface TripleShiftSelectCrumbProps {
  selectedShift: TripleShift;
  setSelectedShift: (shift: TripleShift) => void;
  showAfternoonShift: true;
}

const isNight = (shift: DoubleShift | TripleShift) => shift === "NIGHT";
const shiftIcon = (shift: DoubleShift | TripleShift) => isNight(shift) ? "🌙" : "☀️";
const shiftLabel = (shift: DoubleShift | TripleShift) =>
  `${shift.charAt(0).toUpperCase()}${shift.slice(1).toLowerCase()} Shift`;

export const ShiftSelectCrumb = (props: ShiftSelectCrumbProps | TripleShiftSelectCrumbProps) => {
  const { selectedShift, setSelectedShift, showAfternoonShift } = props;
  const baseClass = `${baseCrumbClasses} flex items-center mx-0.5 justify-center gap-1 text-sm md:text-base transition-colors w-[165px]`;

  if (showAfternoonShift) {
    const shifts: TripleShift[] = ["DAY", "AFTERNOON", "NIGHT"];

    return (
      <ListSelectCrumb<TripleShift>
        options={shifts}
        selectedOption={selectedShift}
        setSelectedOption={s => setSelectedShift(s!)}
        getOptionValue={s => ({ DAY: 1, AFTERNOON: 2, NIGHT: 3 }[s])}
        getOptionLabel={shiftLabel}
        className={`${baseClass} ${isNight(selectedShift) ? "bg-[#2d2964] border border-[#737f90] hover:bg-[#4d4a88] text-[#e0e7ff]" : "bg-[#ea580c] border border-[#e5e7eb] hover:bg-[#c2410c] text-[#f9f9f9]"}`}
        renderSelected={s => (
          <>
            <span>{shiftIcon(s)}</span>
            <span>{shiftLabel(s)}</span>
          </>
        )}
      />
    );
  }

  const handleClick = () => setSelectedShift(selectedShift === "DAY" ? "NIGHT" : "DAY");

  return (
    <button
      className={`${baseClass} ${isNight(selectedShift) ? "bg-[#2d2964] border border-[#737f90] hover:bg-[#4d4a88] text-[#e0e7ff]" : "bg-[#ea580c] border border-[#e5e7eb] hover:bg-[#c2410c] text-[#f9f9f9]"}`}
      onClick={handleClick}
    >
      <span>{shiftIcon(selectedShift)}</span>
      <span>{shiftLabel(selectedShift)}</span>
    </button>
  );
};